function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from 'react';
import { useProgress } from '../../useProgress';
import { propsSpinner } from './constants';
import { ContainerElement, BaseCircle, ProgressbarCircle } from './ProgressCircle.style';
export var ProgressCircle = _ref => {
  var {
    progress = 0,
    size = 'small'
  } = _ref;
  var {
    handleStrokeDasharray
  } = useProgress();
  return /*#__PURE__*/React.createElement(ContainerElement, {
    size: size,
    role: "progressbar"
  }, /*#__PURE__*/React.createElement(BaseCircle, propsSpinner[size]), /*#__PURE__*/React.createElement(ProgressbarCircle, _extends({}, propsSpinner[size], {
    strokeDashoffset: handleStrokeDasharray(progress, propsSpinner[size].strokeDasharray)
  })));
};